
import { useRootStore } from "store";
import { ErrorItem } from "models/errors/errors";
import InformationItem from "views/errorNotifications/components/informationItem/InformationItem";

import "./InformationContainerLayout.scss";

type Props = {
  onCloseErrorClick: (error: ErrorItem) => void;
};

export default function InformationContainerLayout({
  onCloseErrorClick
}: Props) {
  const { errorList:errors } = useRootStore((state) => state.error);

  return (
    <div className="layout">
      {errors.map((error) => {
        return (
          <InformationItem
            onCloseClick={onCloseErrorClick}
            error={error}
            key={error.id}
          />
        );
      })}
    </div>
  );
}
